import { LuTrash2, LuUpload, LuExternalLink } from "react-icons/lu";

export default function DocRow({ label, docName, viewPath, onView, onUpload, onRemove, removable, uploadable, busy }) {
  const hasDoc = Boolean(docName);

  return (
    <div className="rounded-lg border border-slate-200 p-3">
      <p className="mb-2 text-[12.5px] font-medium text-slate-700">{label}</p>
      {hasDoc ? (
        <div className="flex items-center gap-2">
          <button
            onClick={() => onView(viewPath)}
            disabled={busy}
            className="flex flex-1 items-center justify-center gap-1.5 rounded-md bg-brand-gradient px-3 py-1.5 text-[12.5px] font-semibold text-white transition hover:opacity-90 disabled:opacity-60"
          >
            <LuExternalLink size={13} />
            View
          </button>
          {removable && (
            <button
              onClick={onRemove}
              disabled={busy}
              className="flex items-center justify-center gap-1.5 rounded-md border border-red-200 px-3 py-1.5 text-[12.5px] font-medium text-red-600 transition hover:bg-red-50 disabled:opacity-60"
            >
              <LuTrash2 size={13} />
              Remove
            </button>
          )}
        </div>
      ) : (
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[12px] text-slate-400">No document available</p>
          {uploadable && (
            <label
              className={`flex w-fit items-center gap-1.5 rounded-md border border-slate-200 px-3 py-1.5 text-[12.5px] font-medium text-slate-600 transition hover:bg-slate-50 ${
                busy ? "pointer-events-none opacity-60" : "cursor-pointer"
              }`}
            >
              <LuUpload size={13} />
              Upload
              <input type="file" className="hidden" onChange={onUpload} disabled={busy} />
            </label>
          )}
        </div>
      )}
    </div>
  );
}